var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["default"]: () => (__WEBPACK_EXTERNAL_MODULE__canopytax_cp_client_auth_933d3094__["default"]), ["getLoggedInUser"]: () => (__WEBPACK_EXTERNAL_MODULE__canopytax_cp_client_auth_933d3094__.getLoggedInUser), ["getTenant"]: () => (__WEBPACK_EXTERNAL_MODULE__canopytax_cp_client_auth_933d3094__.getTenant) });